import { createSelector } from 'reselect';

import { RootState } from '@/app/store';

import { RollsStatus } from './types';

const selectRollsState = (state: RootState) => state.rolls;

export const selectCurrentRound = createSelector(selectRollsState, (g) => g.currentRound);

export const selectRoundIndex = createSelector(selectCurrentRound, (r) => r.index);

export const selectPlayers = createSelector(selectCurrentRound, (r) => r.players);

export const selectRollsStatus = createSelector(selectCurrentRound, (r) => r.status);

export const selectTotalPot = createSelector(selectCurrentRound, (r) => r.totalPot);
export const selectRollsPotsByCurrency = createSelector(selectCurrentRound, (r) => r.potsByCurrency);
export const selectRollsCurrencyMode = createSelector(selectCurrentRound, (r) => r.currencyMode);
export const selectRollsSelectedCurrency = createSelector(selectRollsState, (g) => g.selectedCurrency);

export const selectCountdown = createSelector(selectCurrentRound, (r) => r.countdownSecondsLeft);

export const selectWinnerId = createSelector(selectCurrentRound, (r) => r.winnerId);

export const selectSpinTargetAngle = createSelector(selectCurrentRound, (r) => r.spinTargetAngle);

export const selectOnlineCounts = createSelector(selectRollsState, (g) => g.onlineCounts);

export const selectOnlineCountByGame = (gameId: string) =>
  createSelector(selectOnlineCounts, (counts) => counts[gameId]);

export const selectServerSeedHash = createSelector(selectCurrentRound, (r) => r.serverSeedHash);

export const selectCanBet = createSelector(
  selectRollsStatus,
  (status) => status === RollsStatus.WAITING || status === RollsStatus.COUNTDOWN,
);

export const selectIsPlayerInRound = createSelector(
  selectPlayers,
  (_: RootState, userId: string) => userId,
  (players, userId) => players.some((p) => p.id === userId),
);

export const selectRollsAutoplay = (state: RootState) => state.rolls.autoplay;
export const selectIsRollsAutoplayActive = (state: RootState) => state.rolls.autoplay.isActive;
export const selectRollsSelectedBalance = createSelector(
  (state: RootState) => state.user.data?.wallets ?? {},
  selectRollsSelectedCurrency,
  (wallets, currency) => wallets[currency]?.balance ?? 0,
);
